import React, { useState } from 'react'

export const InputF = ({ lName,name, placeholder, disabled, value, className, handleInputChange, onBlur, label }) => {
  const [isFocused, setIsFocused] = useState(false);
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">{lName}</label>

      <div className='input-container relative w-full'>
        <input
          className={`appearance-none w-full h-12 px-4 text-sm font-medium text-gray-900 rounded-lg bg-white border border-gray-300 focus:border-secondary focus:ring-[1px] focus:ring-secondary/20 transition-all duration-200 focus-within:outline-0 ${className}`}
          name={name}
          type='text'
          onFocus={() => setIsFocused(true)}
          onBlur={(e) => { setIsFocused(false); if (onBlur) onBlur(e); }}
          value={value}
          onChange={handleInputChange}
          placeholder={placeholder}
          disabled={disabled}
        ></input>
      </div>
    </div>
  )
}



// export const InputTextF = ({ lName,name, placeholder, disabled, value, className, handleInputChange, onBlur, label }) => {
//   return (
//     <div>
//       <label className="block text-sm font-medium text-gray-700 mb-2">{lName}</label>

//       <div className='input-container relative w-full'>
//         <input
//           className={`appearance-none w-full h-12 px-4 text-sm font-medium text-gray-900 rounded-lg bg-white border border-gray-300 focus:border-secondary focus:ring-[1px] focus:ring-secondary/20 transition-all duration-200 focus-within:outline-0 ${className}`}
//           name={name}
//           type='text'
//           onFocus={() => setIsFocused(true)}
//           onBlur={(e) => { setIsFocused(false); if (onBlur) onBlur(e); }}
//           value={value}
//           onChange={handleInputChange}
//           placeholder={placeholder}
//           disabled={disabled}
//         ></input>
//       </div>
//     </div>
//   )
// }


